var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#FF4B69"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4983 10.562C20.4433 10.5529 20.3791 10.5529 20.3241 10.562C19.0591 10.5162 18.0508 9.48037 18.0508 8.19703C18.0508 6.8862 19.1049 5.83203 20.4158 5.83203C21.7266 5.83203 22.7808 6.89537 22.7808 8.19703C22.7716 9.48037 21.7633 10.5162 20.4983 10.562Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5548 17.2355C20.8107 17.4463 22.1948 17.2263 23.1665 16.5755C24.459 15.7138 24.459 14.3022 23.1665 13.4405C22.1857 12.7897 20.7832 12.5697 19.5273 12.7897",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47 10.562C9.525 10.5529 9.58917 10.5529 9.64417 10.562C10.9092 10.5162 11.9175 9.48037 11.9175 8.19703C11.9175 6.8862 10.8633 5.83203 9.5525 5.83203C8.24167 5.83203 7.1875 6.89537 7.1875 8.19703C7.19667 9.48037 8.205 10.5162 9.47 10.562Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.417 17.2355C9.16114 17.4463 7.77698 17.2263 6.80531 16.5755C5.51281 15.7138 5.51281 14.3022 6.80531 13.4405C7.78615 12.7897 9.18864 12.5697 10.4445 12.7897",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9944 17.4116C14.9394 17.4025 14.8752 17.4025 14.8202 17.4116C13.5552 17.3658 12.5469 16.33 12.5469 15.0466C12.5469 13.7358 13.601 12.6816 14.9119 12.6816C16.2227 12.6816 17.2769 13.745 17.2769 15.0466C17.2677 16.33 16.2594 17.375 14.9944 17.4116Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3287 20.2991C11.0363 21.1607 11.0363 22.5724 12.3287 23.4341C13.7954 24.4149 16.1971 24.4149 17.6637 23.4341C18.9562 22.5724 18.9562 21.1607 17.6637 20.2991C16.2062 19.3274 13.7954 19.3274 12.3287 20.2991Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.3fd8759c17a913cfc458313f8d37683b.svg";
export { ForwardRef as ReactComponent };